import { css, useTheme } from '@mui/material'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { useInstantSearch } from 'react-instantsearch'
import {
  cyclingLevel2Categories,
  funLevel2Categories,
  runningLevel2Categories,
  trailLevel2Categories,
  triathlonLevel2Categories,
  walkLevel2Categories
} from 'helpers/raceCategoryLevels'
import { Theme, themeUtils } from 'styles/theme'

const getAllDistancesUrl = (distances: readonly string[]) =>
  distances.reduce((acc: string, elem: string, index: number) => {
    const separator = index === 0 ? '' : '&'
    return acc + separator + 'editionLiveLevel2Category=' + elem
  }, '')

// add Div attributes props
const Empty = ({ ...props }: React.HTMLProps<HTMLDivElement>) => {
  const { t } = useTranslation('common')
  const {
    status,
    results: { nbHits }
  } = useInstantSearch()
  const isSearchStalled = status === 'stalled'
  const theme: Theme = useTheme()

  const runningRacesUrl = `/search?${getAllDistancesUrl(
    runningLevel2Categories
  )}`
  const trailRacesUrl = `/search?${getAllDistancesUrl(trailLevel2Categories)}`
  const triathlonRacesUrl = `/search?${getAllDistancesUrl(
    triathlonLevel2Categories
  )}`
  const funRacesUrl = `/search?${getAllDistancesUrl(funLevel2Categories)}`
  const walkRacesUrl = `/search?${getAllDistancesUrl(walkLevel2Categories)}`
  const cyclingRacesUrl = `/search?${getAllDistancesUrl(
    cyclingLevel2Categories
  )}`

  return isSearchStalled ? (
    <div />
  ) : (
    <>
      {nbHits === 0 && (
        <div
          css={css`
            padding-top: 32px;
          `}
          {...props}
        >
          <div
            css={css`
              padding-bottom: 32px;
              color: ${theme.palette.label.default};
              ${themeUtils.body}
            `}
          >
            {t('eventListing.explore.title')}
            <ul
              css={css`
                padding-top: 8px;

                & li {
                  padding-bottom: 4px;
                  & a {
                    color: ${theme.palette.label.default};
                  }
                }
              `}
            >
              <li>
                <Link href={runningRacesUrl} passHref>
                  {t('eventListing.explore.road')}
                </Link>
              </li>
              <li>
                <Link href={trailRacesUrl} passHref>
                  {t('eventListing.explore.trail')}
                </Link>
              </li>
              <li>
                <Link href={triathlonRacesUrl} passHref>
                  {t('eventListing.explore.triathlon')}
                </Link>
              </li>
              <li>
                <Link href={funRacesUrl} passHref>
                  {t('eventListing.explore.fun_races')}
                </Link>
              </li>
              <li>
                <Link href={walkRacesUrl} passHref>
                  {t('eventListing.explore.walks')}
                </Link>
              </li>{' '}
              <li>
                <Link href={cyclingRacesUrl} passHref>
                  {t('eventListing.explore.bikes')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  )
}

export default Empty
